const harmonyGoodbyeFeedback = `
What worked? 



What didn't work for you? 
  


What could we improve? 



Under what circumstances might you reconsider re-subscribing?



`;


const contactFormTemplates = {
  'harmony-goodbye-feedback': harmonyGoodbyeFeedback
} as const;

export default contactFormTemplates;